import React from 'react';
import {View} from 'react-native';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import {DashboardID} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './EmptyView.style';

export const EmptyView = () => {
  const {ts} = useTranslation('component.partial.PeopleToContact');

  return (
    <View style={styles.base} testID={DashboardID.clientsToContactView}>
      <Icon name={'circle-checkmark'} style={styles.icon} accessible={false} />
      <View style={styles.textContainer} accessible={true}>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          accessible={true}
          accessibilityRole="header"
          variant="heading"
          testID={DashboardID.clientsToContactEmptyViewTitle}>
          {ts('title', 'You’re caught up!')}
        </Text>
        <Text
          allowFontScaling
          maxFontSizeMultiplier={2}
          accessible={true}
          variant="body"
          style={styles.description}
          testID={DashboardID.clientsToContactEmptyViewMessage}>
          {ts(
            'description',
            'Clients with incomplete tasks or reasons for concern will show up here',
          )}
        </Text>
      </View>
    </View>
  );
};
